import React from 'react'

import { ItemCardVariant } from '../ItemCard'
import ItineraryItemCard from '../ItineraryItemCard'

import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import { TourItem } from 'tripPlanner/types/tripItem'
import {
  formatShortDateRange,
  formatSingleDateAndTimeRange,
  formatDurationDaysIfMultipleDays,
} from 'tripPlanner/utils'

interface Props {
  item: TourItem
  onClickTripName?: () => void
  variant: ItemCardVariant
}

export default function CustomTourItemCard({
  item,
  onClickTripName,
  variant,
}: Props) {
  const timeFormat = useRegionTimeFormat()

  const timeDescription =
    item.startDate && item.endDate && !item.endDate.isSame(item.startDate)
      ? formatShortDateRange({
          startDate: item.startDate,
          endDate: item.endDate,
        })
      : formatSingleDateAndTimeRange(item, timeFormat)

  return (
    <ItineraryItemCard
      item={item}
      name={item.name}
      placeId={item.startPlace.type === 'GEO' ? item.startPlace.id : undefined}
      locationDescription={item.startPlace.region}
      descriptors={[timeDescription, formatDurationDaysIfMultipleDays(item)]}
      confirmationCode={item.confirmationCode}
      confirmationCodeLabel="Confirmation number"
      onClickTripName={onClickTripName}
      variant={variant}
      isPlaceRatingsVisible={false}
    />
  )
}
